"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tryParseJson = exports.trimStr = exports.priorityScrollTo = exports.normalizeString = exports.hashString = exports.generateRowId = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _lodash = require("lodash");

var _reactScroll = require("react-scroll");

var hashString = function hashString(str) {
  var hash = 0,
      i,
      chr;
  if (str.length === 0) return hash;

  for (i = 0; i < str.length; i++) {
    chr = str.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }

  return String(hash);
};

exports.hashString = hashString;

var trimStr = function trimStr(str) {
  return str.trim().replace(/\s+/g, ' ');
};

exports.trimStr = trimStr;

var normalizeString = function normalizeString(str) {
  return str.toLowerCase().replace(/\s+/g, '');
};

exports.normalizeString = normalizeString;

var tryParseJson = function tryParseJson(str) {
  try {
    return JSON.parse(str);
  } catch (e) {
    return [];
  }
};

exports.tryParseJson = tryParseJson;

var generateRowId = function generateRowId(section, content) {
  var suffix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  if (typeof content === 'string') {
    return normalizeString((section || '') + content.replace(/[^a-zA-Z0-9]/g, '').substring(0, 250) + (suffix || ''));
  }

  if (typeof content === 'object') {
    var text = '';

    for (var key in content) {
      if (key === 'selection') {
        continue;
      }

      text += "".concat(key, ":").concat(content[key]);
    }

    return normalizeString((section || '') + text + (suffix || ''));
  }
};

exports.generateRowId = generateRowId;
var targetToScrollTo = null;
var debouncedScrollTo = (0, _lodash.debounce)(function () {
  _reactScroll.scroller.scrollTo(targetToScrollTo.id, (0, _objectSpread2.default)({
    smooth: true,
    duration: 1000,
    offset: window.innerHeight / -2
  }, targetToScrollTo.options));

  targetToScrollTo = null;
}, 300, {
  leading: false,
  trailing: true
});

var priorityScrollTo = function priorityScrollTo(id, priority, options) {
  if (!targetToScrollTo || targetToScrollTo.priority > priority) {
    targetToScrollTo = {
      id: id,
      priority: priority,
      options: options
    };
  }

  debouncedScrollTo();
};

exports.priorityScrollTo = priorityScrollTo;